import { create } from 'zustand';
import { loadLocaleIfNeeded } from '../i18n/translationsCore';

export type Language = 'he' | 'en' | 'ru' | 'si' | 'uz' | 'ro';

interface LanguageState {
  language: Language;
  setLanguage: (lang: Language) => void;
}

// Simple localStorage-based persistence
const getStoredLanguage = (): Language => {
  try {
    if (typeof window !== 'undefined' && window.localStorage) {
      const stored = localStorage.getItem('hours-language-storage');
      if (stored) {
        const lang = JSON.parse(stored) as Language;
        // Validate language code
        if (['he', 'en', 'ru', 'si', 'uz', 'ro'].includes(lang)) {
          return lang;
        }
      }
    }
  } catch (e) {
    console.error('Failed to load language from storage', e);
  }
  return 'he'; // Default to Hebrew
};

const persistLanguage = (language: Language) => {
  try {
    if (typeof window !== 'undefined' && window.localStorage) {
      localStorage.setItem('hours-language-storage', JSON.stringify(language));
    }
  } catch (e) {
    console.error('Failed to save language to storage', e);
  }
};

const initialState = getStoredLanguage();

export const useLanguageStore = create<LanguageState>((set) => ({
  language: initialState,
  setLanguage: (lang) => {
    set({ language: lang });
    persistLanguage(lang);
    void loadLocaleIfNeeded(lang);
  },
}));

